import React, {Component} from 'react';
import DatiCompilatore from './DatiCompilatore';
import DatiAnagraficiPaziente from './DatiAnagraficiPaziente';
import StatoVaccinale from './StatoVaccinale';
import InformazioniCliniche from './InformazioniCliniche';
import DatiLaboratorio from './DatiLaboratorio';
import EsitoFollowUp from './EsitoFollowUp';
import Utils from "../../../../../../utils/Utils";
import OggettiUtili from "../../../../../../utils/OggettiUtili.json";
import SessioneUtente from "../../../../../../sessionManager/SessioneUtente";
import Ruoli from "../../../../../../utils/Ruoli";


export default class SchedaSpecialeInfluenzaGrave extends Component {

    state = {
        schedaSpecialeInfluenzaGrave: {
            datiCompilatore: {},
            datiAnagraficiPaziente: {},
            statoVaccinale: {},
            informazioniCliniche: {},
            datiLaboratorio: {},
            esitoFollowUp: {},
            corretto: []
        },
        oggettoBackend: {
            datiCompilatore: {},
            datiAnagraficiPaziente: {},
            statoVaccinale: {},
            informazioniCliniche: {},
            datiLaboratorio: {},
            esitoFollowUp: {}
        },
        validateInfluenza: {
            datiCompilatoreValidate: "",
            datiAnagraficiPazienteValidate: "",
            statoVaccinaleValidate: "",
            informazioniClinicheValidate: "",
            datiLaboratorioValidate: "",
            esitoFollowUpValidate: ""
        }
    }


    constructor(props) {
        super(props);
        this.setDatiCompilatore = this.setDatiCompilatore.bind(this);
        this.setDatiAnagraficiPaziente = this.setDatiAnagraficiPaziente.bind(this);
        this.setStatoVaccinale = this.setStatoVaccinale.bind(this)
        this.setInformazioniCliniche = this.setInformazioniCliniche.bind(this);
        this.setDatiLaboratorio = this.setDatiLaboratorio.bind(this);
        this.setEsitoFollowUp = this.setEsitoFollowUp.bind(this)
        this.createJsonForBackend = this.createJsonForBackend.bind(this)
        this.onSubmit = this.onSubmit.bind(this);
        this.settaCorretto = this.settaCorretto.bind(this)
        this.validate = this.validate.bind(this)

    }

    onSubmit(e) {
        e.preventDefault()
    }

    componentDidMount() {
        this.props.setSchedaSpecialeECorretto(this.state.oggettoBackend)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        let corretto = this.settaCorretto();
        if (prevState !== this.state) {
            let objFinal = this.createJsonForBackend()
            this.props.setSchedaSpecialeECorretto(objFinal, this.validate(), corretto)
        }
    }

    validate() {
        let validate = this.state.validateInfluenza

        for (let key in validate) {
            if (validate[key]) {
                return validate[key]
            }
        }

        return ""
    }

    settaCorretto() {
        let scheda = this.state.schedaSpecialeInfluenzaGrave;
        let textList = []

        if(scheda.datiAnagraficiPaziente.corretto && scheda.datiAnagraficiPaziente.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.datiAnagraficiPaziente.corretto))
        }
        if(scheda.datiCompilatore.corretto && scheda.datiCompilatore.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.datiCompilatore.corretto))
        }
        if(scheda.datiLaboratorio.corretto && scheda.datiLaboratorio.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.datiLaboratorio.corretto))
        }
        if(scheda.esitoFollowUp.corretto && scheda.esitoFollowUp.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.esitoFollowUp.corretto))
        }
        if(scheda.informazioniCliniche.corretto && scheda.informazioniCliniche.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.informazioniCliniche.corretto))
        }
        if(scheda.statoVaccinale.corretto && scheda.statoVaccinale.corretto.length > 0){
            textList = textList.concat(Utils.eliminaNullArray(scheda.statoVaccinale.corretto))
        }

        return textList
    }

    createJsonForBackend() {
        let ObjectForBackEnd = {}
        ObjectForBackEnd = Object.assign({}, Utils.removeFieldFromObject(this.state.oggettoBackend, "corretto"))
        let res = Utils.removeEmptyValueFromObject(ObjectForBackEnd);
        return res;

    }

    setDatiCompilatore(datiCompilatore, validateCompilazioni, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.datiCompilatore = datiCompilatore
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.datiCompilatore = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.datiCompilatoreValidate = validateCompilazioni

        if (datiCompilatore && oggettoBackend && validateCompilazioni) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!datiCompilatore && oggettoBackend && validateCompilazioni) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (datiCompilatore && !oggettoBackend && validateCompilazioni) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (datiCompilatore && oggettoBackend && !validateCompilazioni) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (datiCompilatore && !oggettoBackend && !validateCompilazioni) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!datiCompilatore && oggettoBackend && !validateCompilazioni) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!datiCompilatore && !oggettoBackend && validateCompilazioni) {
            this.setState({validateInfluenza: validate})
        }
    }

    setDatiAnagraficiPaziente(datiAnagraficiPaziente, validateAnagrafica, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.datiAnagraficiPaziente = datiAnagraficiPaziente
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.datiAnagraficiPaziente = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.datiAnagraficiPazienteValidate = validateAnagrafica

        if (datiAnagraficiPaziente && oggettoBackend && validateAnagrafica) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!datiAnagraficiPaziente && oggettoBackend && validateAnagrafica) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (datiAnagraficiPaziente && !oggettoBackend && validateAnagrafica) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (datiAnagraficiPaziente && oggettoBackend && !validateAnagrafica) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (datiAnagraficiPaziente && !oggettoBackend && !validateAnagrafica) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!datiAnagraficiPaziente && oggettoBackend && !validateAnagrafica) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!datiAnagraficiPaziente && !oggettoBackend && validateAnagrafica) {
            this.setState({validateInfluenza: validate})
        }
    }

    setStatoVaccinale(statoVaccinale, validateVaccinale, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.statoVaccinale = statoVaccinale
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.statoVaccinale = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.statoVaccinaleValidate = validateVaccinale

        if (statoVaccinale && oggettoBackend && validateVaccinale) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!statoVaccinale && oggettoBackend && validateVaccinale) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (statoVaccinale && !oggettoBackend && validateVaccinale) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (statoVaccinale && oggettoBackend && !validateVaccinale) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (statoVaccinale && !oggettoBackend && !validateVaccinale) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!statoVaccinale && oggettoBackend && !validateVaccinale) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!statoVaccinale && !oggettoBackend && validateVaccinale) {
            this.setState({validateInfluenza: validate})
        }
    }

    setInformazioniCliniche(informazioniCliniche, validateInfo, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.informazioniCliniche = informazioniCliniche
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.informazioniCliniche = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.informazioniClinicheValidate = validateInfo

        if (informazioniCliniche && oggettoBackend && validateInfo) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!informazioniCliniche && oggettoBackend && validateInfo) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (informazioniCliniche && !oggettoBackend && validateInfo) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (informazioniCliniche && oggettoBackend && !validateInfo) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (informazioniCliniche && !oggettoBackend && !validateInfo) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!informazioniCliniche && oggettoBackend && !validateInfo) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!informazioniCliniche && !oggettoBackend && validateInfo) {
            this.setState({validateInfluenza: validate})
        }
    }

    setDatiLaboratorio(datiLaboratorio, validateDati, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.datiLaboratorio = datiLaboratorio
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.datiLaboratorio = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.datiLaboratorioValidate = validateDati

        if (datiLaboratorio && oggettoBackend && validateDati) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!datiLaboratorio && oggettoBackend && validateDati) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (datiLaboratorio && !oggettoBackend && validateDati) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (datiLaboratorio && oggettoBackend && !validateDati) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (datiLaboratorio && !oggettoBackend && !validateDati) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!datiLaboratorio && oggettoBackend && !validateDati) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!datiLaboratorio && !oggettoBackend && validateDati) {
            this.setState({validateInfluenza: validate})
        }
    }

    setEsitoFollowUp(esitoFollowUp, validateEsito, oggettoBackend) {
        let schedaSpecialeInfluenzaGrave = this.state.schedaSpecialeInfluenzaGrave
        schedaSpecialeInfluenzaGrave.esitoFollowUp = esitoFollowUp
        let oggettiBackend = this.state.oggettoBackend
        oggettiBackend.esitoFollowUp = oggettoBackend
        let validate = this.state.validateInfluenza
        validate.esitoFollowUpValidate = validateEsito

        if (esitoFollowUp && oggettoBackend && validateEsito) {
            this.setState({
                schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave,
                oggettoBackend: oggettiBackend,
                validateInfluenza: validate
            })
        } else if (!esitoFollowUp && oggettoBackend && validateEsito) {
            this.setState({oggettoBackend: oggettiBackend, validateInfluenza: validate})
        } else if (esitoFollowUp && !oggettoBackend && validateEsito) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave, validateInfluenza: validate})
        } else if (esitoFollowUp && oggettoBackend && !validateEsito) {
            this.setState({oggettoBackend: oggettiBackend, schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (esitoFollowUp && !oggettoBackend && !validateEsito) {
            this.setState({schedaSpecialeInfluenzaGrave: schedaSpecialeInfluenzaGrave})
        } else if (!esitoFollowUp && oggettoBackend && !validateEsito) {
            this.setState({oggettoBackend: oggettiBackend})
        } else if (!esitoFollowUp && !oggettoBackend && validateEsito) {
            this.setState({validateInfluenza: validate})
        }
    }


    render() {

        return (<div onSubmit={this.onSubmit}
                     className={SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                         this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice) ? "visualizzazione" : ""}>
            <fieldset
                disabled={SessioneUtente.getInstance().ruoliUtente === Ruoli.Operatore_Laboratorio.descrizione || (this.props.segnalazioneCopia.statoSegnalazione === OggettiUtili.statoSegnalazioneByLabel.Archiviato.codice ||
                    this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice)}>

                <DatiCompilatore
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setDatiCompilatore={this.setDatiCompilatore}
                />
                <DatiAnagraficiPaziente
                    datiPaziente={this.props.datiPaziente}
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setDatiAnagraficiPaziente={this.setDatiAnagraficiPaziente}
                />
                <StatoVaccinale
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setStatoVaccinale={this.setStatoVaccinale}
                />
                <InformazioniCliniche
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setInformazioniCliniche={this.setInformazioniCliniche}
                />
                <DatiLaboratorio
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setDatiLaboratorio={this.setDatiLaboratorio}
                />
                <EsitoFollowUp
                    segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}
                    setEsitoFollowUp={this.setEsitoFollowUp}
                />
            </fieldset>
        </div>)
    }


}
